import React, { Component } from 'react';
import { connect } from 'react-redux';
import sendInformeEmailUseCase from 'tasks/services/sendInformeEmailUseCase';
import sendInvoiceByEmailUseCase from 'invoices/services/sendInvoiceByEmailUseCase';
import findInvoiceDetailByIdUseCase from 'invoices/services/detail/findInvoiceDetailByIdUseCase';
import { getInvoicesData } from 'invoices/services/store/reducers';
import createPDFInvoiceUseCase from 'invoices/services/createPDFInvoice';
import Dialog from '@material-ui/core/Dialog';
import { DialogContent, DialogTitle } from '@material-ui/core';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import DialogDetailTask from 'tasks/components/detail/DialogDetailTask';
import { printDocDevice } from 'tasks/services/printDocsUseCase';
import addObservationUseCase from 'tasks/services/detail/addObservationUseCase';
import deleteObservationUseCase from 'tasks/services/detail/deleteObservationUseCase';
import addPhotoUseCase from 'tasks/services/detail/addPhotoUseCase';
import addSignatureUseCase from 'tasks/services/detail/addSignatureUseCase';
import deletePhotoUseCase from 'tasks/services/detail/deletePhotoUseCase';
import { sendWhatsapp } from 'common/services/util';
import addInvoiceFromTaskUseCase from 'tasks/services/addInvoiceFromTaskUseCase';
import showPDFSignUseCase from 'tasks/services/sign/showPDFSignUseCase';
import findClientByTask from 'tasks/services/sign/findClientByTask';

class TaskDetailsContainer extends Component {
    handlePrintDoc = type => {
        const { taskSelected } = this.props
        if (type === 'Dispositivo') {
            printDocDevice({ dataList: [taskSelected.data] })
        }
    }

    addObservation = (message, messageType) => {
        addObservationUseCase(this.props.taskSelected, message, messageType)
    }

    deleteObservation = (message, messageType) => {
        deleteObservationUseCase(this.props.taskSelected, message, messageType)
    }

    addFile = file => {
        addPhotoUseCase(this.props.taskSelected, file)
    }

    addSignature = signatureImg => {
        addSignatureUseCase(this.props.taskSelected, signatureImg)
    }

    deletePhoto = indexToRemove => {
        deletePhotoUseCase(this.props.taskSelected, indexToRemove)
    }

    sendInforme = async () => {
        const { taskSelected } = this.props;
        const clientData = await findClientByTask(taskSelected.data.dni);

        const url = await showPDFSignUseCase(
            taskSelected.data,
            clientData,
            taskSelected.detail,
            4,
            null
        );
        
        const message = `Estimado cliente, le contactamos desde el Servicio Técnico de IFENO 🛠. A través del siguiente enlace podrá consultar el informe de su reparación: ${url}`;

        // Copiar mensaje al portapapeles
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
            try {
                await navigator.clipboard.writeText(message);
            } catch (err) {
                console.error('❌ Error al copiar al portapapeles', err);
            }
        } else {
            console.warn('Clipboard API no disponible en este navegador');
        }

        // Enviar por whatsapp
        sendWhatsapp(
            taskSelected.data,
            message
        );
    };

    sendInformeEmail = async () => {
        try {
        await sendInformeEmailUseCase(this.props.taskSelected);
        alert("Informe enviado por email ✅");
        } catch (err) {
        if (err.message === "Este cliente no tiene email configurado") {
            alert(err.message);
        } else {
            console.error("❌ Error al enviar informe por email", err);
            alert("Error al enviar el informe por email");
        }
        }
    };

    handleCreateInvoice = () => {
        addInvoiceFromTaskUseCase([this.props.taskSelected.data])
    }

    handleShowPDFSign = async () => {
        const { taskSelected } = this.props
        const clientData = await findClientByTask(taskSelected.data.dni)

        await showPDFSignUseCase(taskSelected.data, clientData, taskSelected.detail, 3, null);
    }

    findLastInvoiceForTask = (isProforma) => {
        const { invoices, taskSelected } = this.props;
        const allInvoices = getInvoicesData(invoices) || [];

        const refTask = taskSelected?.data?.reference;

        // Todas las facturas/proformas del tipo correspondiente
        const sameType = allInvoices.filter(inv =>
            isProforma ? inv.type === 'Proforma' : inv.type !== 'Proforma'
        );

        if (!sameType.length) return null;

        // Ordenarlas por fecha descendente (como en InvoicesContainer)
        const ordered = sameType
            .slice()
            .sort((a, b) => {
                const aD = a.invoiceDate || Number.MAX_SAFE_INTEGER;
                const bD = b.invoiceDate || Number.MAX_SAFE_INTEGER;
                return bD - aD;
            });

        // De esas, quedarnos con las que pertenecen a esta reparación
        const candidates = ordered.filter(inv => inv.taskReference === refTask);
        if (!candidates.length) return null;

        // Última factura/proforma de esta reparación (la más reciente)
        const last = candidates[0];

        // Calcular numInvoice igual que en InvoicesContainer:
        //    numInvoice = total - índice en el array ordenado
        const idxInOrdered = ordered.findIndex(inv => inv.id === last.id);
        const numInvoice = ordered.length - idxInOrdered;

        // devolvemos la factura/proforma con numInvoice calculado
        return { ...last, numInvoice };
    };

    handleSendInvoiceByEmail = async () => {
        try {
            const invoice = this.findLastInvoiceForTask(false);
            if (!invoice) {
                alert('No hay ninguna factura asociada a esta reparación');
                return;
            }

            const detail = await findInvoiceDetailByIdUseCase(invoice.id);

            await sendInvoiceByEmailUseCase({
                invoiceData: invoice,
                invoiceDetail: detail.data,
                isProforma: false
            });

            alert('Factura enviada por email ✅');
        } catch (err) {
            console.error('❌ Error al enviar factura por email', err);
            alert(err.message || 'Error al enviar la factura por email');
        }
    };

    handleSendProformaByEmail = async () => {
        try {
            const proforma = this.findLastInvoiceForTask(true);
            if (!proforma) {
                alert('No hay ninguna proforma asociada a esta reparación');
                return;
            }

            const detail = await findInvoiceDetailByIdUseCase(proforma.id);

            await sendInvoiceByEmailUseCase({
                invoiceData: proforma,
                invoiceDetail: detail.data,
                isProforma: true
            });

            alert('Proforma enviada por email ✅');
        } catch (err) {
            console.error('❌ Error al enviar proforma por email', err);
            alert(err.message || 'Error al enviar la proforma por email');
        }
    };

    handleCreateProforma = () => {
        addInvoiceFromTaskUseCase([this.props.taskSelected.data], true);
    };

    handleSendInvoiceWhatsapp = async () => {
        try {
            const invoice = this.findLastInvoiceForTask(false);
            if (!invoice) {
                alert("No hay ninguna factura asociada a esta reparación");
                return;
            }

            const detail = await findInvoiceDetailByIdUseCase(invoice.id);

            await createPDFInvoiceUseCase({
                invoiceData: invoice,
                initialInvoiceDetailData: { data: detail.data },
                operation: "upload",
                isProforma: false
            });

        } catch (err) {
            console.error(err);
            alert("Error al enviar la factura por WhatsApp");
        }
    };

    handleSendProformaWhatsapp = async () => {
        try {
            const proforma = this.findLastInvoiceForTask(true);
            if (!proforma) {
                alert("No hay ninguna proforma asociada a esta reparación");
                return;
            }

            const detail = await findInvoiceDetailByIdUseCase(proforma.id);

            await createPDFInvoiceUseCase({
                invoiceData: proforma,
                initialInvoiceDetailData: { data: detail.data },
                operation: "upload",
                isProforma: true
            });

        } catch (err) {
            console.error(err);
            alert("Error al enviar la proforma por WhatsApp");
        }
    };

    handleCopyInformeLink = async () => {
        try {
            const { taskSelected } = this.props;
            const clientData = await findClientByTask(taskSelected.data.dni);

            const url = await showPDFSignUseCase(
                taskSelected.data,
                clientData,
                taskSelected.detail,
                4,
                null
            );

            await navigator.clipboard.writeText(url);
            alert("Enlace del INFORME copiado al portapapeles ✅");
        } catch (err) {
            console.error(err);
            alert("No se pudo copiar el enlace del informe");
        }
    };

    handleCopyFacturaLink = async () => {
        try {
            const invoice = this.findLastInvoiceForTask(false);
            if (!invoice) {
                alert("No hay ninguna factura asociada a esta reparación");
                return;
            }

            const detail = await findInvoiceDetailByIdUseCase(invoice.id);

            const url = await createPDFInvoiceUseCase({
                invoiceData: invoice,
                initialInvoiceDetailData: { data: detail.data },
                operation: "email",
                isProforma: false
            });

            await navigator.clipboard.writeText(url);
            alert("Enlace de la FACTURA copiado al portapapeles ✅");
        } catch (err) {
            console.error(err);
            alert("No se pudo copiar el enlace de la factura");
        }
    };

    handleCopyProformaLink = async () => {
        try {
            const proforma = this.findLastInvoiceForTask(true);
            if (!proforma) {
                alert("No hay ninguna proforma asociada a esta reparación");
                return;
            }

            const detail = await findInvoiceDetailByIdUseCase(proforma.id);

            const url = await createPDFInvoiceUseCase({
                invoiceData: proforma,
                initialInvoiceDetailData: { data: detail.data },
                operation: "email",
                isProforma: true
            });

            await navigator.clipboard.writeText(url);
            alert("Enlace de la PROFORMA copiado al portapapeles ✅");
        } catch (err) {
            console.error(err);
            alert("No se pudo copiar el enlace de la proforma");
        }
    };

    render() {
        const { open, handleClose, fullScreen, taskSelected } = this.props;

        return (
            <Dialog
                fullScreen={fullScreen}
                fullWidth={true}
                maxWidth={'xl'}
                open={open}
                onClose={handleClose}
                aria-labelledby="Detalles"
                scroll={"body"}>
                <DialogTitle onClose={handleClose}>{taskSelected.data.deviceName} - {taskSelected.data.reference} 
                </DialogTitle>
                <DialogContent dividers>
                    <DialogDetailTask 
                    taskSelected={taskSelected} 
                    handlePrintDoc={this.handlePrintDoc} 
                    handleClose={handleClose} 
                    addObservation={this.addObservation}
                    deleteObservation={this.deleteObservation}
                    addFile={this.addFile}
                    deletePhoto={this.deletePhoto}
                    addSignature={this.addSignature}
                    sendInforme={this.sendInforme}
                    handleSendReportByEmail={this.sendInformeEmail}
                    handleCreateInvoice={this.handleCreateInvoice}
                    handleShowPDFSign={this.handleShowPDFSign}
                    handleSendInvoiceByEmail={this.handleSendInvoiceByEmail}
                    handleSendProformaByEmail={this.handleSendProformaByEmail}
                    handleSendInvoiceWhatsapp={this.handleSendInvoiceWhatsapp}
                    handleSendProformaWhatsapp={this.handleSendProformaWhatsapp}
                    handleCreateProforma={this.handleCreateProforma}
                    handleCopyInformeLink={this.handleCopyInformeLink}
                    handleCopyFacturaLink={this.handleCopyFacturaLink}
                    handleCopyProformaLink={this.handleCopyProformaLink}
                />
                </DialogContent>

            </Dialog>
        )
    }

}

const mapDispatchToProps = dispatch => ({
});

const mapStateToProps = state => ({
    taskSelected: state.taskSelected,
    invoices: state.invoices.data
});

let connectCmp = connect(mapStateToProps, mapDispatchToProps)(TaskDetailsContainer);
export default withMobileDialog()(connectCmp);